export default __webpack_public_path__ + "static/Seriuos_business-ae3b07142d81ab8cffc1bb1c0424e155.png";